// extracted by mini-css-extract-plugin
module.exports =  {"icon":"XUwN7P0","container":"S0HL6dw","content":"mQvsE9M"};